import { cartOrderPublicClient } from '../../client';

export const getDiscountsEnabledStatus = async (): Promise<boolean> => {
  const response = await cartOrderPublicClient(3).get<{
    enabled: boolean;
  }>(`/discounts/enabled`);
  return response.data.enabled;
};

export type DiscountEligibilityResult =
  | {
      eligible: true;
    }
  | {
      eligible: false;
      expired?: true;
      hasAccountDiscount?: true;
      ineligibleUser?: true;
      invalid?: true;
      programOnly?: true;
    };

export const verifyUserDiscountEligibility = async (
  code?: string,
): Promise<DiscountEligibilityResult> => {
  const response = await cartOrderPublicClient(
    3,
  ).get<DiscountEligibilityResult>(
    '/accounts/verify-user-discount-eligibility',
    {
      params: code ? { code } : undefined,
    },
  );

  return response.data;
};
